module.exports = __webpack_public_path__ + "static/media/p4-11.34d24fee.png";